"use client";

import * as React from "react";
import MasonryItem, { MasonryCoreItem } from "./MasonryItem";

type MasonryProps<T extends MasonryCoreItem = MasonryCoreItem> = {
  items: T[];
  animateFrom?: "bottom" | "top" | "left" | "right" | "scale" | "fade";
  ease?: string;
  duration?: number;  // seconds
  stagger?: number;   // seconds
  scaleOnHover?: boolean;
  hoverScale?: number;
  blurToFocus?: boolean;
  colorShiftOnHover?: boolean;
  renderItem?: (item: T, index: number) => React.ReactNode;
  className?: string;
};

export default function Masonry<T extends MasonryCoreItem>({
  items,
  animateFrom = "bottom",
  ease = "power3.out",
  duration = 0.6,
  stagger = 0.05,
  scaleOnHover = true,
  hoverScale = 0.97,
  blurToFocus = true,
  colorShiftOnHover = false,
  renderItem,
  className,
}: MasonryProps<T>) {
  return (
    <div
      className={[
        "columns-1 sm:columns-2 lg:columns-3",
        "gap-4 md:gap-2",
        className || "",
      ].join(" ")}
    >
      {items.map((item, i) => (
        <MasonryItem<T>
          key={item.id}
          item={item}
          index={i}
          animateFrom={animateFrom}
          ease={ease}
          duration={duration}
          stagger={stagger}
          scaleOnHover={scaleOnHover}
          hoverScale={hoverScale}
          blurToFocus={blurToFocus}
          colorShiftOnHover={colorShiftOnHover}
          renderItem={renderItem}
        />
      ))}
    </div>
  );
}
